import { inject } from '@angular/core';
import { AuthService } from '../../services/auth-service/auth.service';
import { Observable, of, switchMap } from 'rxjs';
import { OBSERVABILITY_FACADE } from '../../services/facades';

/**
 * @description
 * Used to ensure that shared global data is loaded before every guard/resolver within the MyTCPortal.
 */
export const mytcPortalGuard: () => Observable<boolean> = () => {
  const authService = inject(AuthService);
  const observabilityFacade = inject(OBSERVABILITY_FACADE);

  return authService.syncUserData().pipe(
    switchMap((myTcUser) => {
      const isLoggedIn = !!myTcUser;

      if (isLoggedIn) {
        observabilityFacade.setUserId({ userId: myTcUser.UserId });

        return of(true);
      }

      observabilityFacade.removeUserId();

      return of(true);
    }),
  );
};
